export const siteHasAdminClaim = site =>
  Array.isArray(site?.claims) &&
  site.claims.some(
    claim => typeof claim === 'string' && claim.toLowerCase() === 'admin',
  )

export const hasAdminClaimOnAnySite = sites =>
  Array.isArray(sites) && sites.some(siteHasAdminClaim)

export const getSitesWithAdminClaim = sites => {
  if (!Array.isArray(sites)) return []
  return sites.filter(siteHasAdminClaim)
}
